var _defs, _g, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardBackChimps2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 51.8 84.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .card-back-small-text {\n        font-size: 14px;\n      }\n\n      .card-back-accent {\n        fill: #967BB6;\n      }\n\n      .card-back-accent, .card-back-fill, .card-back-white {\n        stroke-width: 0px;\n      }\n\n      .card-back-fill {\n        fill: #66369D;\n      }\n\n      .card-back-logo {\n        fill: #FFF;\n        font-family: Courgette-Regular, Courgette;\n      }\n\n      .card-back-white {\n        fill: #fff;\n      }\n\n      .card-back-large-text {\n        font-size: 20px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "card-back-fill",
    d: "m1.4,0h49c.7,0,1.4.6,1.4,1.3v82c0,.8-.6,1.3-1.4,1.3H1.4c-.7,0-1.4-.6-1.4-1.3V1.3C0,.6.7,0,1.4,0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "card-back-white",
    cx: 49.7,
    cy: 2.1,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "card-back-white",
    cx: 2.1,
    cy: 2.1,
    r: 0.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "card-back-white",
    cx: 49.7,
    cy: 82.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "card-back-white",
    cx: 2.1,
    cy: 82.6,
    r: 0.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "card-back-accent",
    d: "m11.76,44.53l.45-.56-.11-.11c-.45-1-.45-2.23,0-3.23l12.92-28.5c.11-.33.56-.56.89-.56h0c.45,0,.78.22.89.56l4.68,10.47.67-.22-4.68-10.47c-.22-.56-.89-1-1.56-1h0c-.67,0-1.22.33-1.56,1l-12.8,28.5c-.56,1.22-.56,2.56,0,3.79l.22.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "card-back-accent",
    d: "m39.26,38.07l-.56.45.89,2c.45,1,.45,2.23,0,3.23l-12.8,28.62c-.11.33-.56.56-.89.56h0c-.45,0-.78-.22-.89-.56l-2.23-4.9-.67.22,2.23,5.01c.22.56.89,1,1.56,1h0c.67,0,1.22-.33,1.56-1l12.8-28.5c.56-1.22.56-2.56,0-3.79l-1-2.34Z"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "card-back-logo",
    transform: "translate(20.03 65.5) rotate(-63.66)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "card-back-large-text",
    x: 0,
    y: 0
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    className: "card-back-small-text",
    x: 10.67,
    y: 0
  }, "himps"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardBackChimps2);
export default __webpack_public_path__ + "static/media/card-back-chimps2.e337da182cb9541277716b15fb7b35a9.svg";
export { ForwardRef as ReactComponent };